<div class="row justify-content-center position-relative col-12" style="margin-top: 7vh;">
  <div class="col-10">
    <div style="z-index: 100;background-color: white;"
      class="row col-10 pt-3 justify-content-between align-items-center position-fixed">
      <h2 class="font-weight-bold text-uppercase align-items-center pt-3 d-flex">
        <span style="color:#2a3749">{{tableName}}</span>
        <a href={{wikiLink}} target="_blank" class="ml-1 d-flex align-items-center">
          <i class="fas fa-lightbulb clickable wiki-icon mb-1" ngbTooltip="Wiki link" placement="left"></i>
        </a>
      </h2>
      <div class="row mr-4">
        <button class="btn text-white mr-2 trigger-collapse-btn bulk-delete mr-2" type="button" title="Delete {{tableName}}(s)" (click)="deleteSelectedItems()" *ngIf="setDeleteAll">
          DELETE
        </button>
        <button class="btn btn-filter text-white mr-2 trigger-collapse-btn" title="Filter" data-toggle="collapse"
          data-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
          <i class='fas fa-filter'></i></button>
        <div *ngIf="this.createNew.observers.length === 0">
          <button class="btn text-white create-btn" [routerLink]="['new']"><i class="fas fa-plus"></i> CREATE</button>
        </div>
        <div *ngIf="this.createNew.observers.length > 0">
          <button class="btn create-btn text-white" (click)="createNewItem()"><i class="fas fa-plus"></i> CREATE</button>
        </div>
      </div>
    </div>
    <div class="filterContent">
      <div class="collapse " id="collapseExample">
        <ng-content></ng-content>
      </div>
    </div>
    <table class="table list-table-design">
      <thead class="TableHead" [ngClass]="{
        'table-head-show-endpoint': showAction && router.url.includes('/endpoint'),
        'table-head-show-action': showAction && !router.url.includes('/endpoint'),
        'table-head-hide-action': !showAction
      }">
        <tr class="list-table-row">
          <th *ngIf="showAction"><input type="checkbox" [(ngModel)]="isAllSelected" (click)="toggleAllItems()" [disabled]="!user.superAdmin" /></th>
          <th *ngFor="let rowData of tableHead">{{rowData}}</th>
          <th width="10%" *ngIf="showAction">Action</th>
        </tr>
      </thead>
      <tbody>
        <div *ngIf="collectionSize === 0" style="display: grid;" class="mt-5 pt-5 justify-content-center">
          <img height="100px" src="/assets/images/icons/empty_message.png" alt="/assets/images/icons/empty_message.png">
          <p style="color: gray;" class="ml-3 mt-1"><b>No Data Found</b></p>
        </div>
        <tr>
          <td colspan="6" *ngIf="collectionSize === null">
            <div class="skeleton mb-3" *ngFor="let i of [80, 100, 70]" [style.width]="i + '%'"></div>
            <div class="skeleton mb-3" *ngFor="let i of [80, 100, 70]" [style.width]="i + '%'"></div>
          </td>
        </tr>
        <div *ngIf="list">
          <ng-content select=[tableContent]></ng-content>

        </div>
        <div *ngIf="list.length === 0 && collectionSize && collectionSize !== 0">
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
        </div>
      </tbody>
    </table>
    <div class="row my-4 pb-5" *ngIf="list.length > 0">
      <div class="col font-weight-bold">Total {{tableName}}s : {{ collectionSize || 0 }}</div>
      <div class="col-1" *ngIf="list">
        <select class="" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
          <option>15</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
      <div class="col-md-auto" *ngIf="list && list">
        <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="5"
          [pageSize]="pageSize" [(page)]="page" [boundaryLinks]="true" [rotate]="true"
          (pageChange)="onPageChange($event)"></ngb-pagination>
      </div>
    </div>
  </div>
</div>